academicAwards:
  - month: 8
    name:
      en: |
        The SoCS 2026 Best Student Paper Award (w/Tomoki Arita)
      ja: |
        The SoCS 2026 Best Student Paper Award (慶應大・有田さんとの共著)
    url: https://socs26.search-conference.org/home
    year: 2026
  - month: 2
    name:
      en: Funai Information Technology Award for Young Researchers
      ja: 船井研究奨励賞
    url: https://funaifoundation.jp/news-580.htm
    year: 2026
  - month: 3
    name:
      en: Ph.D. Dissertation Award (Seiichi Tejima Research Award), Tokyo Institute of Technology
      ja: 東京工業大学 手島精一記念研究賞 (博士論文賞)
    url: https://educ.titech.ac.jp/cs/news/2024_05/066030.html
    year: 2024
  - month: 5
    name: The ICAPS 2022 Best Student Paper Award
    url: https://icaps22.icaps-conference.org/awards.html
    year: 2022
  - month: 10
    name: Nomination Award of the 2021 Microsoft Research Asia Fellowship
    url: https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/articles/eleven-phd-students-are-awarded-the-2021-microsoft-research-asia-fellowship-award/
    year: 2021

menteeAwards:
  - month: 9
    name:
      en: |
        Fumimaro Suzuki. The Student Encouragement Award, SMASH26 (Japanese domestic conference)
      ja: |
        鈴木史麿. SMASH26 Summer Symposium 研究奨励賞 \& 電子情報通信学会 人工知能と知識処理専門委員会 研究奨励賞
    url: https://sites.google.com/view/sig-macc/smash/smash26-summer-symposium/%E8%A1%A8%E5%BD%B02608
    year: 2026
  - month: 8
    name:
      en: |
        Tomoki Arita. The SoCS 2026 Best Student Paper Award
      ja: |
        有田朋樹. The SoCS 2026 Best Student Paper Award
    year: 2026
    url: https://socs26.search-conference.org/
  - month: 3
    name:
      en: |
        Tsukasa Ueshima. The Student Encouragement Award, IPSJ (Japanese domestic conference)
      ja: |
        上島 司. 情報処理学会 学生奨励賞
    url: https://www.ipsj.or.jp/event/taikai/89/award.html
    year: 2026

grant:
  - description:
      en: |
        "Large-Scale Multi-Robot Coordination via Neuro-Guided Multi-Agent Search" / 40,000,000 JPY
      ja: |
        「マルチエージェント探索と模倣学習による大規模ロボット群協調」/ 4,000万円
    name:
      en: |
        JST PRESTO "Real-World Intelligence Fundamentals" (PI) / Project Number: JPMJPR2513
      ja: |
        JST さきがけ「実世界知能システムの基盤創出」(代表) / 課題番号 JPMJPR2513
    term:
      en: Oct. 2025 - Mar. 2029
      ja: 2025年10月 - 2029年3月
    url:
      en: https://www.jst.go.jp/kisoken/presto/en/research_area/area2025-3.html
      ja: https://www.jst.go.jp/kisoken/presto/research_area/bunya2025-3.html
      #
  - description:
      en: |
        "Efficient search for planning problems with huge branching factor" /
        5,000,000 JPY (maximum)
      ja: "「巨大な分岐因子をもつプランニング問題における探索」/ 最大500万円"
    name:
      en: |
        JSPS Grant-in-Aid for Early-Career Scientists (PI) / Project Number: 25K21289
      ja: |
        JSPS 科研費 若手研究 (代表) / 課題番号 25K21289
    term:
      en: Apr. 2025 - Mar. 2029
      ja: 2025年4月 - 2029年3月
    url: https://www.jst.go.jp/kisoken/act-x/news/2025/250401/2025_accelerationphase.pdf
    #
  - description:
      en: |
        "Environment Optimization for Multi-Agent Path Planning" / 5,000,000 JPY (maximum)
      ja: 「マルチエージェント経路計画のための環境最適化」/ 最大500万円
    name:
      en: |
        JST ACT-X, acceleration phase "AI powered Research Innovation / Creation" (PI) / Project Number: JPMJAX22A1
      ja: |
        JST ACT-X 加速フェーズ「AI活用で挑む学問の革新と創成」(代表) / 課題番号: JPMJAX22A1
    term:
      en: Apr. 2025 - Mar. 2026
      ja: 2025年4月 - 2026年3月
    url:
      https://www.jst.go.jp/kisoken/act-x/news/2025/250401/2025_accelerationphase.pdf
      #
  - description:
      en: |
        "New Horizons of Multi-Robot Motion Planning by Integrating Sampling, Search, and Learning Techniques"
        / approx. 15,000,000 JPY financial support for staying overseas research institute
      ja: |
        「サンプリング・探索・学習の統合によるマルチロボットモーションプランニングの新展開」/ 約1500万円の滞在費・研究活動費
    name:
      en: JSPS Overseas Research Fellowship
      ja: 日本学術振興会 海外特別研究員
    term:
      en: May. 2023 - Apr. 2025
      ja: 2023年5月 - 2025年4月
    url:
      en: https://www.jsps.go.jp/english/e-ab/index.html
      ja: https://www.jsps.go.jp/j-ab/
  - description:
      en: |
        "Environment Optimization for Multi-Agent Path Planning" / 6,000,000 JPY (maximum), selection ratio: 89/421=21.1%
      ja: "「マルチエージェント経路計画のための環境最適化」/ 最大600万円, 採択率: 89/421=21.1%"
    name:
      en: |
        JST ACT-X "AI powered Research Innovation / Creation" (PI) / Project Number: JPMJAX22A1
      ja: |
        JST ACT-X「AI活用で挑む学問の革新と創成」 (代表) / 課題番号: JPMJAX22A1
    term:
      en: Oct. 2022 - Mar. 2025
      ja: 2022年10月 - 2025年3月
    url:
      en: https://www.jst.go.jp/kisoken/act-x/en/project/111F003/111F003_2022.html
      ja: https://www.jst.go.jp/kisoken/act-x/project/111F003/111F003_2022.html
  - description:
      en: |
        "Designing Distributed Algorithms for a Modular Environment Enhancing Cooperative Robots" / 1,400,000 JPY for staying abroad, selection ratio: 55/111=49.5%
      ja: "「ロボット群の制御を行うモジュール型環境における分散アルゴリズムの開発 」/ 140万円の海外滞在費, 採択率: 55/111=49.5%"
    name:
      en: JSPS Overseas Challenge Program for Young Researchers (PI)
      ja: 日本学術振興会 若手研究者海外挑戦プログラム (代表)
    term:
      en: Mar. 2022 - Sep. 2022
      ja: 2022年3月 - 2022年9月
    url:
      en: https://www.jsps.go.jp/english/e-abc/index.html
      ja: https://www.jsps.go.jp/j-abc/index.html
  - description:
      en: |
        "Enhanced Cooperation of Moving Agents via an Active Modular Environment" /
        200,000 JPY monthly scholarship + 2,800,000 JPY research funding, selection ratio: 721/3711=19.4%
      ja: "「移動エージェント群の協調行動を誘発する環境による計算支援 」/ 20万円/月の奨学金+研究費280万円, 採択率: 721/3711=19.4%"
    name:
      en: "JSPS Research Fellowship DC1 / Project Number: 20J23011"
      ja: "日本学術振興会 特別研究員 DC1 / 課題番号: 20J23011"
    term:
      en: Apr. 2020 - Mar. 2023
      ja: 2020年4月 - 2023年3月
    url: https://kaken.nii.ac.jp/grant/KAKENHI-PROJECT-20J23011/
  - description:
      en: 200,000 JPY monthly scholarship + 3,500,000 JPY study supports, only 5-6 Ph.D.
        Candidates in Japan/Year
      ja: "20万円/月の生活援助及びおよそ350万円/3年の学費等の援助, 採択: 5人程度/年"
    name:
      en: Yoshida Scholarship Foundation Doctor21
      ja: 吉田育英会 ドクター21
    term:
      en: Apr. 2020 - Mar. 2023
      ja: 2020年4月 - 2023年3月
    url:
      en: https://www.ysf.or.jp/scholarship/visitor/internal/doctor21.php
      ja: https://www.ysf.or.jp/scholarship/visitor/internal/doctor21.php
  - description:
      en: "2,112,000 JPY, selection ratio: 1456/21538=6.7%"
      ja: "211万2千円の学費等の援助/2年, 採択率: 1456/21538=6.7%"
    name:
      en: JASSO Repayment Exemption for Students with Excellent Grades
      ja: 日本学生支援機構 第一種奨学金 全額返済免除
    term:
      en: Apr. 2018 - Mar. 2020
      ja: 2018年4月 - 2020年3月
    url:
      en: https://www.jasso.go.jp/shogakukin/taiyochu/gyosekimenjyo/index.html
      ja: https://www.jasso.go.jp/shogakukin/taiyochu/gyosekimenjyo/index.html

otherAwards:
  - month: 9
    name:
      en: Outstanding Presentation Award, The 17th Workshop on Theoretical Computer
        Science (WTCS)
      ja: 第17回情報科学ワークショップ 優秀プレゼンテーション賞
    url: https://w-tcs.github.io/2021/
    year: 2021
  - month: 4
    name:
      en: Outstanding Performance Award, Fixstars Amplify Hackathon
      ja: Fixstars Amplify ハッカソン, 優秀賞
    url: https://amplify.fixstars.com/hackathon00
    year: 2021
  - month: 9
    name:
      en: Outstanding Presentation Award, The 16th Workshop on Theoretical Computer
        Science (WTCS)
      ja: 第16回情報科学ワークショップ 優秀プレゼンテーション賞
    url: https://w-tcs.github.io/2020/
    year: 2020
  - month: 9
    name:
      en: The Best Research Award, The 15th Workshop on Theoretical Computer Science
        (WTCS)
      ja: 第15回情報科学ワークショップ 最優秀研究賞
    url: https://w-tcs.github.io/2019/
    year: 2019
  - month: 3
    name:
      en: The Best Research Award, The 17th Microsymposium on Complex Systems
      ja: 第17回複雑系マイクロシンポジウム 最優秀研究賞
    year: 2018
  - month: 9
    name:
      en: The Outstanding Presentation Award, The 13rd Workshop on Theoretical Computer
        Science (WTCS)
      ja: 第13回情報科学ワークショップ 優秀プレゼンテーション賞
    url: https://w-tcs.github.io/2017
    year: 2017
  - month: 4
    name:
      en: Incentive award of director of School of Computing, School of Computing at Tokyo Institute of Technology
      ja: 平成28年度 情報理工学院 学院長奨励賞
    year: 2017
  - month: 2
    name:
      en: "TokyoTech Engineering Design Competition: First Prize"
      ja: "第三回東工大エンジニアリングコンペティション: 優勝"
    url: http://www.eng.titech.ac.jp/~cbe/competition2017/
    year: 2017
  - month: 12
    name:
      en: MashupAward 2016 Student Division, First Prize
      ja: Mashup Awards 2016 学生部門最優秀賞
    url: https://ma2017.we-are-ma.jp/2016/11/final-student/
    year: 2016
  - month: 11
    name:
      en: "JPHACKS 2016: Best Idea Prize + 6 Other Awards"
      ja: "JPHACKS 2016: Best Idea賞+他6賞"
    url: https://2016.jphacks.com/
    year: 2016
  - month: 6
    name:
      en: "HackU@Tokyo-Tech 2016 sponserd by Yahoo! Japan: TokyoTech Prize"
      ja: "Hack U 東京工業大学 2016: 東京工業大学賞"
    url: https://hacku.yahoo.co.jp/titech2016/
    year: 2016
  - month: 5
    name:
      en: Microsoft Community Champion, First Place in Domestic Qualify
      ja: Microsoft Community Champion 国内予選一位通過
    year: 2015
